import {
  Alert,
  alpha,
  Button,
  Divider,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { timezones } from "./fusoHorarios";

export default function EasyLogConfig() {
  const { setSubTitle, setChanges, settings, erpErrors, setErpErrors } =
    useOutletContext();
  const theme = useTheme();
  const produto = "easylogs";
  const KEYS_TO_ENCRYPT = [
    "userErp",
    "bancoErp",
    "portaErp",
    "senhaErp",
    "linkBanco",
    "portaBanco",
    "servidorErp",
  ];

  // estados de formulário
  const [linkBanco, setLinkBanco] = useState("");
  const [portBanco, setportBanco] = useState("");
  const [defCGNAT, setDefCGNAT] = useState(false);
  const [timezone, setTimezone] = useState("");
  const [erpStatus, setErpStatus] = useState(false);
  const [erpSelect, setErpSelect] = useState("");
  const [servidorErp, setServidorErp] = useState("");
  const [userErp, setUserErp] = useState("");
  const [senhaErp, setSenhaErp] = useState("");
  const [bancoErp, setERP] = useState("");
  const [colectionTime, setColectionTime] = useState("");
  const [portaErp, setPortaErp] = useState("");

  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const md = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    setSubTitle("EasyLogs");
  }, [setSubTitle]);

  useEffect(() => {
    if (!settings) return;
    let settingsData = settings.find((item) => item.produto === produto);

    setportBanco(settingsData?.configuracoes?.portaBanco || "");
    setLinkBanco(settingsData?.configuracoes?.linkBanco || "");
    setDefCGNAT(settingsData?.configuracoes?.typeBpa || false);
    setTimezone(settingsData?.configuracoes?.timeZone || "America/Sao_Paulo");
    setErpStatus(settingsData?.configuracoes?.erpStatus || false);
    setErpSelect(settingsData?.configuracoes?.erpType || "ixc");
    setServidorErp(settingsData?.configuracoes?.servidorErp || "");
    setUserErp(settingsData?.configuracoes?.userErp || "");
    setSenhaErp(settingsData?.configuracoes?.senhaErp || "");
    setERP(settingsData?.configuracoes?.bancoErp || "");
    setPortaErp(settingsData?.configuracoes?.portaErp || "");
    setColectionTime(settingsData?.configuracoes?.colectionTime || 5);
  }, [settings]);

  const styles = {
    textFieldSelect: {
      "& .MuiInputBase-input": { fontSize: "0.875rem" },
      "& .MuiOutlinedInput-root": {
        background: alpha(theme.palette.background.paper, 0.7),
        ":hover": { background: alpha(theme.palette.background.paper, 0.9) },
      },
      minWidth: "min-content",
    },
    labels: { fontSize: "14px", fontWeight: 500, color: "text.primary" },
    text: { fontSize: "0.95rem", fontWeight: 500 },
    textFine: {
      fontSize: "0.86rem",
      mt: "-2px",
      color: theme.palette.text.shadow,
    },
    boxOP: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid" + theme.palette.background.paperOutlined,
      p: 2,
      borderRadius: "5px",
    },
    textField: {
      fontSize: "14px",
      width: "100%",
      "& .MuiInputBase-input": {
        fontSize: "0.9rem",
        height: "20px!important",
      },
      '& input[type="number"]::-webkit-outer-spin-button': { display: "none" },
      '& input[type="number"]::-webkit-inner-spin-button': { display: "none" },
      '& input[type="number"]': { MozAppearance: "textfield" },
      "& .MuiOutlinedInput-root": {
        boxShadow: "none",
        "&.Mui-focused": { boxShadow: "none", border: "none" },
      },
    },
    textAdorment: {
      ml: "-5px",
      fontSize: "0.875em",
      fontWeight: 800,
      color: theme.palette.text.disabled,
      width: "max-content",
    },
    containerPredefinicoes: {
      ml: "0px",
      mr: "0px",
      p: "10px 15px",
      mt: 2,
      width: "100%",
      borderRadius: "5px",
      backgroundColor: theme.palette.background.textField,
    },
  };

  // Handler de salvar com validação

  const handleChange = (key, value) => {
    setChanges((data) => ({
      product: produto,
      settings: {
        ...data?.settings,
        keysToEncrypt: KEYS_TO_ENCRYPT,
        [key]: value,
      },
    }));
  };

  return (
    <Stack gap={2} mb={8}>
      {/* === Link do Banco === */}
      <Paper sx={styles.boxOP}>
        <Stack direction="column">
          <Typography sx={styles.text}>Banco</Typography>

          <Typography sx={{ ...styles.textFine }}>
            Informe o endereço do banco de registro de logs
          </Typography>

          <Stack justifyContent={"center"} gap={2} mt={1} direction={"row"}>
            <TextField
              fullWidth
              sx={styles.textField}
              onChange={(e) => {
                handleChange("linkBanco", e.target.value);
                setLinkBanco(e.target.value);
              }}
              value={linkBanco}
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={styles.textAdorment}>IP</Typography>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <TextField
              sx={{ ...styles.textField, width: "150px" }}
              onChange={(e) => {
                handleChange("portaBanco", e.target.value);
                setportBanco(e.target.value);
              }}
              value={portBanco}
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={styles.textAdorment}>Porta</Typography>
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Stack>
          {(!linkBanco || linkBanco == "") && (
            <Alert sx={{ mt: 1 }} severity="info">
              Ainda não possui um banco configurado? Entre em contato com o
              suporte para obter ajuda!
            </Alert>
          )}
        </Stack>
      </Paper>

      {/* === Predefinições (CGNAT, Fuso, ERP) === */}
      <Paper sx={styles.boxOP}>
        <Typography sx={styles.text}>Predefinições</Typography>
        <Stack sx={styles.containerPredefinicoes}>
          {/* Tipo de Log */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack>
              <Typography sx={styles.text}>Tipo de Log</Typography>
              <Typography sx={styles.textFine}>
                Selecione se deseja ativar o CGNAT; caso contrário, o NAT padrão
                será utilizado
              </Typography>
            </Stack>
            <Switch
              size="small"
              checked={defCGNAT}
              onChange={(e) => {
                setDefCGNAT(e.target.checked);
                handleChange("typeBpa", e.target.checked);
              }}
            />
          </Stack>

          <Divider sx={{ my: 1 }} />

          {/* Fuso Horário */}
          <Stack
            direction={md ? "row" : "column"}
            alignItems={md ? "center" : "start"}
            justifyContent="space-between"
            gap={2}
          >
            <Stack>
              <Typography sx={styles.text}>Horário Local</Typography>
              <Typography sx={styles.textFine}>
                Informe o seu fuso horário para garantir que os horários
                exibidos estejam corretos de acordo com a sua localização.
              </Typography>
            </Stack>
            <TextField
              sx={styles.textFieldSelect}
              slotProps={{
                select: {
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        maxHeight: 250,
                      },
                    },
                  },
                },
              }}
              select
              value={timezone}
              size="small"
              onChange={(e) => {
                setTimezone(e.target.value);
                handleChange("timeZone", e.target.value);
              }}
            >
              {timezones.map((item) => (
                <MenuItem key={item.value} value={item.query}>
                  {item.zona}
                </MenuItem>
              ))}
            </TextField>
          </Stack>

          <Divider sx={{ my: 1 }} />

          {/* Integração ERP */}
          <Stack
            direction="column"
            alignItems={md ? "center" : "start"}
            gap={2}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Stack>
                <Typography sx={styles.text}>Integração com ERP</Typography>
                <Typography sx={styles.textFine}>
                  Ative a integração com o ERP para relacionar os logs com as
                  informações dos seus clientes.
                </Typography>
              </Stack>
              <Switch
                size="small"
                checked={erpStatus}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setErpStatus(checked);
                  if (!checked) {
                    setErpErrors({
                      servidorErp: false,
                      portaErp: false,
                      bancoErp: false,
                      userErp: false,
                      senhaErp: false,
                    });
                  }
                  handleChange("erpStatus", checked);
                }}
              />
            </Stack>
            {erpStatus && (
              <Stack width="100%" gap={2}>
                {/* Tipo de ERP */}
                <Stack
                  // justifyContent={"space-between"}
                  direction={md ? "row" : "column"}
                  gap={2}
                >
                  <TextField
                    autoComplete="off"
                    sx={{
                      ...styles.textFieldSelect,
                      width: md ? "15%" : "100%",
                    }}
                    select
                    value={erpSelect}
                    onChange={(e) => {
                      const v = e.target.value;
                      setErpSelect(v);
                      handleChange("erpType", v);
                      if (v && erpErrors.erpType) {
                        setErpErrors((p) => ({ ...p, erpType: false }));
                      }
                    }}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              ERP
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  >
                    <MenuItem value="ixc">IXC</MenuItem>
                    <MenuItem value="hubsoft">Hubsoft</MenuItem>
                    <MenuItem value="sgp">SGP</MenuItem>
                  </TextField>
                  <TextField
                    value={colectionTime}
                    autoComplete="off"
                    size="small"
                    type="number"
                    error={erpErrors.portaErp}
                    helperText={
                      erpErrors.portaErp
                        ? "Preencha a frequência da coleta"
                        : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setColectionTime(v);
                      handleChange("colectionTime", v);
                      if (v && erpErrors.colectionTime) {
                        setErpErrors((p) => ({ ...p, colectionTime: false }));
                      }
                    }}
                    sx={{
                      ...styles.textFieldSelect,
                      width: md ? "20%" : "100%",
                    }}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Frequência da coleta
                            </Typography>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <Typography sx={styles.textAdorment}>
                              min
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>
                {/* Servidor e Porta */}
                <Stack direction="row" gap={2}>
                  <TextField
                    value={servidorErp}
                    autoComplete="off"
                    size="small"
                    fullWidth
                    error={erpErrors.servidorErp}
                    helperText={
                      erpErrors.servidorErp ? "Preencha o servidor ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setServidorErp(v);
                      handleChange("servidorErp", v);
                      if (v && erpErrors.servidorErp) {
                        setErpErrors((p) => ({ ...p, servidorErp: false }));
                      }
                    }}
                    sx={styles.textFieldSelect}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Servidor
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                  <TextField
                    value={portaErp}
                    autoComplete="off"
                    size="small"
                    type="number"
                    error={erpErrors.portaErp}
                    helperText={
                      erpErrors.portaErp ? "Preencha a porta do ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setPortaErp(v);
                      handleChange("portaErp", v);
                      if (v && erpErrors.portaErp) {
                        setErpErrors((p) => ({ ...p, portaErp: false }));
                      }
                    }}
                    sx={{ ...styles.textFieldSelect, width: "150px" }}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Porta
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>

                {/* Banco */}
                <TextField
                  value={bancoErp}
                  autoComplete="off"
                  size="small"
                  fullWidth
                  error={erpErrors.bancoErp}
                  helperText={erpErrors.bancoErp ? "Preencha o banco ERP" : ""}
                  onChange={(e) => {
                    const v = e.target.value.trim();
                    setERP(v);
                    handleChange("bancoErp", v);
                    if (v && erpErrors.bancoErp) {
                      setErpErrors((p) => ({ ...p, bancoErp: false }));
                    }
                  }}
                  sx={{
                    ...styles.textFieldSelect,
                    width: "100%",
                  }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography sx={styles.textAdorment}>
                            Banco
                          </Typography>
                        </InputAdornment>
                      ),
                    },
                  }}
                />

                {/* Usuário e Senha */}
                <Stack direction="row" gap={2}>
                  <TextField
                    value={userErp}
                    autoComplete="off"
                    size="small"
                    fullWidth
                    error={erpErrors.userErp}
                    helperText={
                      erpErrors.userErp ? "Preencha o usuário ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setUserErp(v);
                      handleChange("userErp", v);
                      if (v && erpErrors.userErp) {
                        setErpErrors((p) => ({ ...p, userErp: false }));
                      }
                    }}
                    sx={styles.textFieldSelect}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Usuário
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                  <TextField
                    value={senhaErp}
                    autoComplete="off"
                    size="small"
                    type="password"
                    fullWidth
                    error={erpErrors.senhaErp}
                    helperText={
                      erpErrors.senhaErp ? "Preencha a senha ERP" : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      setSenhaErp(v);
                      handleChange("senhaErp", v);
                      if (v && erpErrors.senhaErp) {
                        setErpErrors((p) => ({ ...p, senhaErp: false }));
                      }
                    }}
                    sx={styles.textFieldSelect}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              Senha
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Stack>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
}
